import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { navigate } from 'gatsby'
import { animated, useSpring } from 'react-spring'
import { COLORS, ROUTES } from 'config/constants'
import { scrollIntoView } from 'utils/helpers'
import { Box } from 'components/atoms/Layout'
import { fontSizes, space, springConfig } from 'config/theme'
import Link from 'routes/components/Link'
import Container from 'components/atoms/Container'
import { MENU_HEIGHT } from '../Header'

const MobileMenuContainer = styled(animated.div)`
  background-color: ${COLORS.WHITE};
  position: fixed;
  top: ${MENU_HEIGHT};
  bottom: 0;
  right: 0;
  width: 100%;
  overflow-y: auto;
`

const NavLink = styled(Link)`
  display: block;
  font-size: ${fontSizes.xl};
  font-weight: bold;
  padding: ${space.m};
  text-transform: uppercase;
`

const MobileMenu = ({ isVisible, onClick }) => {
  const slideLeftConditional = useSpring({
    from: { transform: `translateX(100%)` },
    to: {
      transform: isVisible ? `translateX(0)` : `translateX(100%)`,
    },
    ...springConfig,
  })
  return (
    <MobileMenuContainer style={slideLeftConditional}>
      <Container>
        <Box py="m" textAlign="right">
          {ROUTES.map(({ name, path }) => (
            <NavLink key={name} to={path} onClick={onClick}>
              {name}
            </NavLink>
          ))}
          <NavLink
            onClick={() => {
              navigate('/')
              scrollIntoView('rent-form')
              onClick()
            }}
            color="brandCta"
          >
            SEE IF YOU QUALIFY
          </NavLink>
        </Box>
      </Container>
    </MobileMenuContainer>
  )
}

MobileMenu.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default MobileMenu
